<div class="blog-dialog">

    <!-- Dialog header -->
    <header class="dialog-header">
        <div class="header-content">
            <div class="header-icon">
                <mat-icon>article</mat-icon>
            </div>

            <div>
                <h2>Blog Details</h2>
                <p>View blog content and publishing information</p>
            </div>
        </div>

        <button mat-icon-button type="button" aria-label="Close dialog" mat-dialog-close (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </header>

    <mat-divider />

    <!-- Scrollable content -->
    <mat-dialog-content class="dialog-content">

        <!-- Blog information -->
        <section class="blog-heading">
            <div class="blog-badges">
                <span class="blog-id">Blog #{{ blog.blog_id }}</span>

                <span class="status-badge" [class.published]="isPublished(blog.status)"
                    [class.unpublished]="!isPublished(blog.status)">
                    {{ blog.status || 'Unknown' }}
                </span>

                <span class="visibility-badge" [class.active]="isActive(blog.is_active)"
                    [class.inactive]="!isActive(blog.is_active)">
                    {{ isActive(blog.is_active) ? 'Active' : 'Inactive' }}
                </span>
            </div>

            <h1>{{ blog.title }}</h1>

            <div class="blog-meta">
                <span>
                    <mat-icon>person_outline</mat-icon>
                    {{ blog.author || 'Unknown author' }}
                </span>

                <span>
                    <mat-icon>calendar_today</mat-icon>
                    {{ blog.created_date | date:'dd MMM yyyy, hh:mm a' }}
                </span>
            </div>
        </section>

        <!-- Featured image -->
        <section class="featured-image" *ngIf="imageUrl">
            <img [src]="imageUrl" [alt]="blog.title" />
        </section>

        <!-- Short description -->
        <section class="content-section">
            <div class="section-heading">
                <mat-icon>short_text</mat-icon>
                <h3>Short Description</h3>
            </div>

            <div class="html-content short-description" [innerHTML]="blog.short_description"></div>
        </section>

        <mat-divider />

        <!-- Full article -->
        <section class="content-section">
            <div class="section-heading">
                <mat-icon>description</mat-icon>
                <h3>Full Blog Content</h3>
            </div>

            <article class="html-content article-content" [innerHTML]="blog.description"></article>
        </section>

        <mat-divider />

        <!-- SEO details -->
        <section class="content-section seo-section">
            <div class="section-heading">
                <mat-icon>manage_search</mat-icon>
                <h3>SEO Metadata</h3>
            </div>

            <div class="seo-grid">

                <div class="seo-item">
                    <span class="field-label">Meta Title</span>
                    <p>{{ blog.meta_title || 'Not configured' }}</p>
                </div>

                <div class="seo-item">
                    <span class="field-label">H1 Tag</span>
                    <p>{{ blog.h1_tag || 'Not configured' }}</p>
                </div>

                <div class="seo-item full-width">
                    <span class="field-label">Meta Keywords</span>
                    <p>{{ blog.meta_keywords || 'Not configured' }}</p>
                </div>

                <div class="seo-item full-width">
                    <span class="field-label">Meta Description</span>
                    <p>{{ blog.meta_description || 'Not configured' }}</p>
                </div>

            </div>
        </section>

        <mat-divider />

        <!-- Timestamps -->
        <section class="content-section timestamps-section">
            <div class="section-heading">
                <mat-icon>schedule</mat-icon>
                <h3>Record Information</h3>
            </div>

            <div class="timestamp-grid">
                <div>
                    <span class="field-label">Created Date</span>
                    <p>{{ blog.created_date | date:'dd MMM yyyy, hh:mm a' }}</p>
                </div>

                <div>
                    <span class="field-label">Last Updated</span>
                    <p>{{ blog.updated_date | date:'dd MMM yyyy, hh:mm a' }}</p>
                </div>
            </div>
        </section>

    </mat-dialog-content>

    <!-- Footer -->
    <mat-divider />

    <footer class="dialog-footer">
        <span>Blog ID: {{ blog.blog_id }}</span>

        <button mat-flat-button color="primary" type="button" (click)="close()">
            <mat-icon>close</mat-icon>
            Close
        </button>
    </footer>

</div>